import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import FailureSummary from './FailureSummary';
import SortIcons from './ProposalsSortIcons';

const FailureSummaryList = ({ faxes, onSort, sortValue }) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => faxes.length > 0 && onSort('date')}>
              Date <SortIcons sortObj={sortValue} sortName="date" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('totalFailed')}
            >
              Total Failed <SortIcons sortObj={sortValue} sortName="totalFailed" />
            </th>
            <th className="cursor-pointer" onClick={() => faxes.length > 0 && onSort('reason')}>
              Reason <SortIcons sortObj={sortValue} sortName="reason" />
            </th>
          </tr>
        </thead>
        <tbody>
          {faxes.length ? (
            faxes.map(fax => <FailureSummary fax={fax} />)
          ) : (
            <tr>
              <td colSpan={12}>
                <Alert rowSpan={12} color="info">
                  No Failed Summary Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(FailureSummaryList);
